<template>
    <div>
         <b-col sm="12">
        <b-card no-body >
            <b-card-body>
                <h5 class="heading-1 mb-4">
                    <span>ETAPAS COM FATURAMENTO EM ATRASO</span>
                </h5>
                <pnl-vencimentos-etapas 
                    v-if="pnlVencimentos"
                    :pnlVencimentos="pnlVencimentos" 
                    :etapasPorPeriodo="pnlVencimentos"
                    @filtrar="filtrarPorPeriodo">
                </pnl-vencimentos-etapas>
            </b-card-body>
        </b-card>
        </b-col>
        <b-col sm="12">
            <b-card no-body>
                <b-card-header>
                    <span class="h5">Etapas</span>
                </b-card-header>
                <b-card-body>
                    <b-row>
                        <!-- <b-col>
                            <b-form-group>
                                <strong>
                                    <label>Filtro por Faturamento</label>
                                </strong>
                                <b-form-select :plain="true" :options="statusFaturamentoSelect"
                                    v-model="statusFaturamento"></b-form-select>
                            </b-form-group>
                        </b-col> -->
                        <!-- <b-col sm="6">
                            <b-form-group>
                                <strong>
                                    <label>Filtro por Status</label>
                                </strong>
                                <b-form-select :plain="true" :options="statusEtapasSelect"
                                    v-model="statusEtapa"></b-form-select>
                            </b-form-group>
                        </b-col> -->
                    </b-row>
                    <app-tabela 
                    idTabela="tblEtapas" 
                    :itens="etapasFiltradas" 
                    :campos="campos"
                        :itensPorPagina="itensPorPagina" 
                        :bordered="false" :small="false">
                        <template slot="botoes">
                            <slot name="botoes"></slot>
                        </template>
                        <template slot="status" slot-scope="data">
                            <app-status :status="data.status.toUpperCase()"></app-status>
                        </template>
                        <template slot="valorHora" slot-scope="data">{{
                            data.valorHora | currency
                        }}</template>
                        <template slot="qtdDespesas" slot-scope="data">{{
                            data.despesas ? data.despesas.length : 0
                        }}</template>
                        <template slot="valorDespesas" slot-scope="data">{{
                            data.valorDespesas | currency
                        }}</template>
                        <template slot="idMov" slot-scope="data">
                            {{ data.idMov }}
                        </template>
                        <template slot="valorTotal" slot-scope="data">{{
                            data.valorTotal | currency
                        }}</template>
                    </app-tabela>
                </b-card-body>
            </b-card>
        </b-col>
    </div>
</template>

<script>
import EtapasServicos from './EtapasServicos'
import PnlVencimentosEtapas from './../../componentes/etapas/PnlVencimentosEtapas.vue';


export default {
    components: {
        PnlVencimentosEtapas
    },
    name: 'Etapas',
    data() {
        return {
           etapas: [],
            pnlVencimentos: null,
            etapasFiltradas: [],
            campos: [
                // {
                //     key: 'acoes',
                //     label: 'Ações'
                // },
                {
                    key: 'nomeCredenciada',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'natureza',
                    label: 'Tipo Natureza',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'codProjeto',
                    label: 'Código Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'idEtapa',
                    label: 'Parcela',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'idEtapaCliente',
                    label: 'Etapa',
                    sortable: true,
                    filterable: true
                },
                
                {
                    key: 'projeto',
                    label: 'Projeto',
                    sortable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    sortable: true
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true
                },
                {
                    key: 'horasEtapa',
                    label: 'Qtd Horas',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'valorHora',
                    label: 'Valor Hora',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'qtdDespesas',
                    value: 'Qtd Despesas',
                    tdClass: 'text-center'
                },
                {
                    key: 'valorDespesas',
                    label: 'Valor Despesas',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                },
                
                {
                    key: 'status',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'idMov',
                    label: 'Comprometimento',
                    filterable: true
                },
                {
                    key: 'diasAtraso',
                    label: 'Dias em Atraso',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'dataPagamento',
                    label: 'Registro de Pagamento',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                }
            ],
            itensPorPagina: 10,
            statusEtapa: 'TODAS',
            statusFaturamento: 'TODAS',
            statusFaturamentoSelect: ['TODAS', 'PAGAS', 'EM ABERTO'],
            statusEtapasSelect: [],
            periodoSelecionado: 0,

            exibirTimeline: false,
            filtro: '',
            filter: null,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            isLoading: false
        }
    },
    computed: {
        etapasComputadas() {
            // Obter IDs das etapas com mais de 60 dias do pnlVencimentos
            const etapasAcima61Dias = this.pnlVencimentos?.diasAcima61 || [];
            
            return this.etapas.map(etapa => ({
                ...etapa,
                codprojeto: etapa.codProjeto,
                projeto: etapa.rateio && etapa.rateio.length > 0 ? etapa.rateio[0].projeto : '',
                acao: etapa.rateio && etapa.rateio.length > 0 ? etapa.rateio[0].acao : '',
                unidade: etapa.rateio && etapa.rateio.length > 0 ? etapa.rateio[0].unidade : '',
                // Colorir linha se o etapaId estiver na lista de etapas acima de 60 dias
                _rowVariant: etapasAcima61Dias.includes(etapa.etapaId) ? 'danger' : null
            }));
        }
    },
    created() {
        this.obterEtapas()
        this.obterEtapasPorVencimentos()
    },
    methods: {
        obterEtapas() {
            this.$store.dispatch('addRequest')
            EtapasServicos.obterEtapasFaturadasNaoQuitadas().then((response) => {
                if (response) {
                    
                    if (response.success) {
                        this.etapas = response.data || []
                    } else {
                        this.$toast.error(
                            'Erro ao obter etapas faturadas não quitadas',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        obterEtapasPorVencimentos() {
            this.$store.dispatch('addRequest')
            EtapasServicos.obterEtapasPorVencimentos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.pnlVencimentos = response.data
                        
                        // Garantir que os arrays existam
                        if (this.pnlVencimentos) {
                            this.pnlVencimentos.dias30 = this.pnlVencimentos.dias30 || []
                            this.pnlVencimentos.dias31a45 = this.pnlVencimentos.dias31a45 || []
                            this.pnlVencimentos.dias46a60 = this.pnlVencimentos.dias46a60 || []
                            this.pnlVencimentos.diasAcima61 = this.pnlVencimentos.diasAcima61 || []
                        }
                    
                    } else {
                        this.erros = ['Erro ao obter etapas por prazos']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        
        filtrarPorPeriodo(filtro) {
            this.periodoSelecionado = filtro.periodo
            if (filtro.periodo > 0) {
                this.filtrarPorEtapasIds(filtro.etapasIds)
            } else {
                this.processarFiltro()
            }
        },
        filtrarPorEtapasIds(etapasIds) {
            let etapasTemp = [...this.etapasComputadas]
            
            // Se não há etapasIds ou está vazio, não deve mostrar nenhuma etapa
            if (!etapasIds || etapasIds.length === 0) {
                this.etapasFiltradas = []
                return
            }
            
            etapasTemp = etapasTemp.filter(etapa => etapasIds.includes(etapa.etapaId))
            
            if (this.statusFaturamento != 'TODAS') {
                if (this.statusFaturamento == 'PAGAS') {
                    etapasTemp = etapasTemp.filter(
                        (p) => p.statusIdFat == 'F' || p.statusIdFat == 'Q'
                    )
                }
                if (this.statusFaturamento == 'EM ABERTO') {
                    etapasTemp = etapasTemp.filter(
                        (p) => p.statusIdFat != 'F' && p.statusIdFat != 'Q'
                    )
                }
            }
            if (this.statusEtapa != 'TODAS') {
                if (this.statusEtapa == 'ATRASADAS') {
                    // Filtrar etapas atrasadas (aprovadas há mais de 60 dias e não faturadas)
                    const hoje = new Date()
                    hoje.setHours(0, 0, 0, 0)
                    
                    etapasTemp = etapasTemp.filter(etapa => {
                        if (etapa.status !== 'CONCLUÍDO' || etapa.statusIdFat === 'F') return false
                        if (!etapa.terminoEtapa) return false
                        
                        const dataTermino = new Date(etapa.terminoEtapa)
                        dataTermino.setHours(0, 0, 0, 0)
                        const diferencaDias = Math.floor((hoje - dataTermino) / (1000 * 60 * 60 * 24))
                        
                        return diferencaDias > 60
                    })
                } else {
                    etapasTemp = etapasTemp.filter(
                        (p) => p.status == this.statusEtapa
                    )
                }
            }
            
            this.etapasFiltradas = [...etapasTemp]
        },
        processarFiltro() {
            if (!this.etapasComputadas || this.etapasComputadas.length === 0) {
                this.etapasFiltradas = []
                return
            }
            
            let etapasTemp = [...this.etapasComputadas]
            
            if (this.statusFaturamento != 'TODAS') {
                if (this.statusFaturamento == 'PAGAS') {
                    etapasTemp = etapasTemp.filter(
                        (p) => p.statusIdFat == 'F' || p.statusIdFat == 'Q'
                    )
                }
                if (this.statusFaturamento == 'EM ABERTO') {
                    etapasTemp = etapasTemp.filter(
                        (p) => p.statusIdFat != 'F' && p.statusIdFat != 'Q'
                    )
                }
            }
            if (this.statusEtapa != 'TODAS') {
                if (this.statusEtapa == 'ATRASADAS') {
                    // Filtrar etapas atrasadas (aprovadas há mais de 60 dias e não faturadas)
                    const hoje = new Date()
                    hoje.setHours(0, 0, 0, 0)
                    
                    etapasTemp = etapasTemp.filter(etapa => {
                        if (etapa.status !== 'CONCLUÍDO' || etapa.statusIdFat === 'F') return false
                        if (!etapa.terminoEtapa) return false
                        
                        const dataTermino = new Date(etapa.terminoEtapa)
                        dataTermino.setHours(0, 0, 0, 0)
                        const diferencaDias = Math.floor((hoje - dataTermino) / (1000 * 60 * 60 * 24))
                        
                        return diferencaDias > 60
                    })
                } else {
                    etapasTemp = etapasTemp.filter(
                        (p) => p.status == this.statusEtapa
                    )
                }
            }
            this.etapasFiltradas = [...etapasTemp]
        },
        filtrar() {
            this.filter = this.filtro
        },
        abrirEtapa(etapa) {
            this.$router.push({ name: 'Sgtec_Fornecedores_Etapa_Detalhar', params: { etapaId: etapa.id } })
        },
        
        obterEtapasIdsPorPeriodo(periodo) {
            if (!this.pnlVencimentos) return []
            
            switch (periodo) {
                case 4: return this.pnlVencimentos.dias30 || []
                case 3: return this.pnlVencimentos.dias31a45 || []
                case 2: return this.pnlVencimentos.dias46a60 || []
                case 1: return this.pnlVencimentos.diasAcima61 || []
                default: return []
            }
        },

        calcularDiasAtraso(dataStatusIdMov) {
            if (!dataStatusIdMov) return 0
            
            const hoje = new Date()
            hoje.setHours(0, 0, 0, 0)
            
            const dataStatus = new Date(dataStatusIdMov)
            dataStatus.setHours(0, 0, 0, 0)
            
            const diferencaMs = hoje.getTime() - dataStatus.getTime()
            const diferencaDias = Math.floor(diferencaMs / (1000 * 60 * 60 * 24))
            
            return diferencaDias
        }
    },
    watch: {
        etapasComputadas() {
            if (this.etapasComputadas && this.etapasComputadas.length > 0) {
                // Obter status únicos das etapas
                const statusList = this.etapasComputadas.map(item => item.status).filter(Boolean);
                this.statusEtapasSelect = Array.from(new Set(statusList));
                this.statusEtapasSelect.unshift('ATRASADAS', 'TODAS');
                this.processarFiltro();
            }
        },

        statusEtapa() {
            if (this.periodoSelecionado > 0) {
                // Se há um período selecionado, reaplica o filtro por período
                this.filtrarPorPeriodo({
                    periodo: this.periodoSelecionado,
                    etapasIds: this.obterEtapasIdsPorPeriodo(this.periodoSelecionado)
                })
            } else {
                this.processarFiltro()
            }
        },

        statusFaturamento() {
            if (this.periodoSelecionado > 0) {
                // Se há um período selecionado, reaplica o filtro por período
                this.filtrarPorPeriodo({
                    periodo: this.periodoSelecionado,
                    etapasIds: this.obterEtapasIdsPorPeriodo(this.periodoSelecionado)
                })
            } else {
                this.processarFiltro()
            }
        }
    }
}
</script>
